export enum CreateGraduatingYearFormFields {
  classYear = 'classYear',
  alumniCount = 'alumniCount',
}
